import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';

import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Trans } from 'react-i18next';

@observer
export class ContributionForm extends Modal {
  render() {
    const { manager } = modalStore.props;
    const { form } = manager;
    const {
      conf: { formTitle },
    } = form;

    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={form}
          formTitle=''
          buttonHandler={manager.CommitContribution}
          noBorder={true}
          padding='0'
        />
      </>
    );
  }
}
